export default "__VITE_ASSET__CvF3hJ41__"